import { Close, PendingActions } from '@mui/icons-material';
import { Box, CircularProgress, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { Campaign } from 'domains/campaigns/types';
import useCampaignAudit from 'hooks/queries/useCampaignAudit';
import ActivityList from './ActivityList';

type Props = {
    campaign?: Campaign;
    isOpen: boolean;
    onClose: () => void;
};

const DRAWER_WIDTH = 720;

const ActivitySidesheet = ({ campaign, isOpen, onClose }: Props) => {
    const campaignId = campaign?.id?.toString() || '';

    const { data: auditData, isInitialLoading: isLoading, isError } = useCampaignAudit(campaignId, {
        enabled: isOpen && !!campaignId,
    });

    return (
        <Drawer
            anchor="right"
            open={isOpen}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: DRAWER_WIDTH,
                    maxWidth: '100%',
                },
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: 3,
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
            >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <PendingActions sx={{ color: 'text.secondary' }} />
                    <Typography variant="h6" fontWeight="bold">
                        Activities
                    </Typography>
                </Stack>
                <IconButton onClick={onClose} size="small">
                    <Close />
                </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ padding: 3, flex: 1, overflow: 'auto' }}>
                {isLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                )}
                {isError && <Typography color="error">Failed to load activity data</Typography>}
                {!isLoading && !isError && auditData && <ActivityList data={auditData} campaignName={campaign?.name} />}
            </Box>
        </Drawer>
    );
};

export default ActivitySidesheet;
